exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subImg[data-v-236c167a]{display:-webkit-box;display:-ms-flexbox;display:flex}.subImg img[data-v-236c167a]{width:100px;height:100px;margin-right:10px}.img-preview-dialog .el-dialog__body[data-v-236c167a]{padding:10px 20px 20px 20px}", ""]);

// exports
